import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ErrorPage from "~/ui/Pages/ErrorPage/ErrorPage";

import { PageSpinner, View, WithBaseStyles } from "~/native-ui"

const Overlay = WithBaseStyles(View, {
	defaultProps: {
		position: "absolute",
		zIndex: 10,
		top: 0,
		left: 0,
		w: "100%",
		h: "100%",
		bg: "white",
		opacity: 0,
		pointerEvents: "none",
	}
})

export default class LoadingContainer extends Component {
	static propTypes = {
        ready: PropTypes.bool.isRequired,
		loading: PropTypes.bool.isRequired,
		error: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	};

	static defaultProps = {
	    ready: false,
        loading: false
    };
	
	renderContent = () => {
		const overlayProps = !this.props.loading ? { } : {
			opacity: 0.5,
			pointerEvents: "all"
		}
	    return (
            <React.Fragment>
                <Overlay { ...overlayProps} />
                
                {this.props.children}
            </React.Fragment>
        );
    };
	
	renderError = () => {
        return <ErrorPage error={this.props.error} />
    };
	
	render() {
	    let { ready, error } = this.props,
            content;
	    
	    if(error) {
	        content = this.renderError();
        } else {
	        content = ready ? this.renderContent() : <PageSpinner />;
        }
	    
		return content;
	}
}